<template>
  <div>
    <header>
      <HeaderPhotobook />
      <BreadcrumbList />
    </header>
    <div class="contentsBox">
      <div id="photobookTalkshow" class="photobookBox">
        <section id="photobookTalkshowTitle">
          <div class="inner4">
            <h2>東京カメラ部2020写真展 公式写真集<br>「それでも世界は美しい。」発売記念オンライントークショー</h2>
            <h1>「あなたを幸せにしてくれる世界のかけら」</h1>
            <p class="date">10月25日（日）18:00-19:00</p>
            <p class="youtubeTcc">東京カメラ部 公式Youtubeチャンネルにてライブ配信</p>
          </div>
        </section>
        <section id="photobookTalkshowVisual">
          <div class="inner4">
            <img src="/img/photobook_ts_visual.jpg" alt="「あなたを幸せにしてくれる世界のかけら」">
          </div>
        </section>

        <section id="photobookTalkshowBody">
          <div class="inner4">
            <p class="intro">日経ナショナル ジオグラフィック社 書籍編集長 尾崎憲和氏と、東京カメラ部10選2019の佐藤悠大氏、谷田洋史氏、Hiroki Nose氏、東京カメラ部運営の5人で、東京カメラ部2020写真展 公式写真集「それでも世界は美しい」をテーマに作品、そして写真集制作の意図や裏側について語るトークショー。東京カメラ部 公式Youtubeチャンネルにてライブ配信いたします。</p>
            <h3><img src="/img/photobook_ts_spkTitle.png" alt="SPEAKERS"></h3>
            <div class="photobookTsSpk">
              <img src="/img/photobook_ts_spk01.jpg" alt="日経ナショナル ジオグラフィック社 書籍編集長 尾崎 憲和氏"><img src="/img/photobook_ts_spk02.jpg" alt="10選2019 佐藤 悠大氏"><img src="/img/photobook_ts_spk03.jpg" alt="10選2019 谷田 洋史氏"><img src="/img/photobook_ts_spk04.jpg" alt="10選2019 Hiroki Nose氏"><img src="/img/photobook_ts_spk05.jpg" alt="東京カメラ部代表 塚崎 秀雄">
            </div>
            <p class="liveTxt">ライブ配信はこちらから</p>
            <a class="StandardBtn liveTxtBtn" href="https://www.youtube.com/channel/UCtZRu7ZjkEXjQytAX1CVf-Q" target="_blank">東京カメラ部 公式Youtubeチャンネル</a>

          </div>
        </section>

        <section id="photobookExhibition">
          <h3>発売記念 <br class="sp">10選2019作品プリント展示</h3>
          <div class="inner4">
            <img src="/img/photobookProjectsExhibition.jpg" alt="10選2019作品プリント展示">
            <div class="photobookExhibitionTxt">
              <p>本写真展公式写真集を発刊していただく⽇経ナショナル ジオグラフィック社さんのご協⼒によって、新10選の皆様の10選  作品（合計10作品）の展⽰（A2サイズ）を「⼋重洲ブックセンター本店」「MARUZEN＆ジュンク堂書店梅⽥店」にて開催いただけることとなりました。</p>
              <router-link to="/photobook/exhibition">詳しくはこちら</router-link>
            </div>
          </div>
        </section>
        <section id="photobookIntro">
          <div class="inner4">
            <PhotobookIntro />
          </div>
        </section>
        <PhotobookSeries />
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import HeaderPhotobook from '@/components/modules/HeaderPhotobook.vue'
import BreadcrumbList from '@/components/modules/BreadcrumbList.vue'
import PhotobookIntro from '@/components/modules/PhotobookIntro.vue'
import PhotobookSeries from '@/components/modules/PhotobookSeries.vue'
import Footer from '@/components/modules/Footer.vue'

export default {
  components: {
    HeaderPhotobook,
    BreadcrumbList,
    PhotobookIntro,
    PhotobookSeries,
    Footer
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.contentsBox {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
